<template>
    <div
        ref="sivukarttaModalContent"
        role="dialog"
        aria-modal="true"
        aria-labelledby="id-modalHeadingSivukartta"
        @keydown.tab="trapFocus"
    >
        <header class="modal-header">
            <h1
                id="id-modalHeadingSivukartta"
                ref="modalHeadingSivukartta"
                tabindex="0"
                @keydown.tab="handleHeadingTab"
            >
                {{ header }}
            </h1>
            <button
                ref="modalButtonSivukartta"
                type="button"
                class="btn-close"
                :aria-label="closeModalAriaLabel"
                @click="close"
                @keydown.esc="close"
            />
        </header>
        <section class="modal-body modal-font">
            <div>
                <sivukartta-router-link :links="links" />
            </div>
        </section>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"
    import PageLinkUtils from "../../helpers/pageLinkUtils"
    import SivukarttaRouterLink from "@/components/SivukarttaRouterLink.vue"

    @Component({
        components: {
            "sivukartta-router-link": SivukarttaRouterLink
        }
    })
    export default class SivukarttaModal extends Vue {
        @Prop({ type: Boolean, default: false }) componentNameIsSet!: boolean

        pageLinkUtils = new PageLinkUtils()

        mounted(): void {
            if (this.componentNameIsSet === true) {
                this.$nextTick(() => {
                    (this.$refs.modalHeadingSivukartta as HTMLHeadingElement).focus()
                })
            }
        }

        close(): void {
            this.$store.dispatch("setModalComponentName", "")
        }

        get links() {
            const groupedLinks = {}

            const allLinks = this.pageLinkUtils.getEtusivuLinkObject()
                .concat(this.pageLinkUtils.getLiikenneLinksWithSubtopics())
                .concat(this.pageLinkUtils.getViestintaLinksWithSubtopics())

            allLinks.forEach(link => {
                const page = link.pageName

                if (!groupedLinks[page]) {
                    groupedLinks[page] = []
                }

                groupedLinks[page].push(link)
            })

            return groupedLinks
        }

        get textContent(): string | null {
            return this.$t("App.Sivukartta.InfoText") ?? ""
        }

        get header(): string | null {
            return this.$t("App.Sivukartta.Header") ?? ""
        }

        get closeModalAriaLabel(): string | undefined {
            return this.$t("App.Close")
        }

        trapFocus(event: KeyboardEvent) {
            const focusableElementsString = "a[href], button:not([disabled])"
            let focusableElements: HTMLElement[] = []

            if (this.$refs.sivukarttaModalContent instanceof HTMLElement) {
                focusableElements = Array.from((this.$refs.sivukarttaModalContent as Element).querySelectorAll<HTMLElement>(focusableElementsString))
            }

            const firstTabStop = focusableElements[0]
            const lastTabStop = focusableElements[focusableElements.length - 1]

            // Tarkistetaan, mikä event ja mikä modaalin elementti kyseessä ja siirrytään sen mukaan
            if (event.key === "Tab" || event.keyCode === 9) {
                if (event.shiftKey) /* shift + tab */ {
                    if (document.activeElement === firstTabStop) {
                        event.preventDefault()
                        lastTabStop?.focus()
                    }
                    else {
                        const index = focusableElements.indexOf(document.activeElement as HTMLElement)
                        const element = focusableElements[index - 1] as HTMLElement
                        element.focus()
                        event.preventDefault()
                    }
                }
                else /* tab */ {
                    if (document.activeElement === lastTabStop) {
                        event.preventDefault()
                        firstTabStop?.focus()
                    }
                    else {
                        const index = focusableElements.indexOf(document.activeElement as HTMLElement)
                        const element = focusableElements[index + 1] as HTMLElement
                        element.focus()
                        event.preventDefault()
                    }
                }
            }
        }

        handleHeadingTab(event: KeyboardEvent): void {
            if (event.shiftKey) /* shift + tab */ {
                (this.$refs.modalButtonSivukartta as HTMLButtonElement).focus()
                event.preventDefault()
            }
        }
    }
</script>
